// extracted by mini-css-extract-plugin
export default {"lists":"AppointmentsHistory_lists__2ojIf","list":"AppointmentsHistory_list__bu7G+","viewMore":"AppointmentsHistory_viewMore__zIHCG"};